//@flow
import _ from 'lodash'

export const isPopupBlockerEnabled = (window: typeof window): boolean => {
  return _.isUndefined(window) || _.isNull(window)
}

export const hasAdBlock = (): boolean => _.isUndefined(global.hasAdBlock) || global.hasAdBlock
